import React, { ReactNode } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, IconButton, Typography, Stack, Divider, Box } from '@mui/material';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import PrintStyles from './Registration/PrintStyles';

type ReportDialogProps = {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
  onDownload?: () => void;
  onPrint?: () => void;
  showActions?: boolean;
  downloadLabel?: string;
  printLabel?: string;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
};

const ReportDialog: React.FC<ReportDialogProps> = ({
  open,
  onClose,
  title,
  children,
  onDownload,
  onPrint,
  showActions = true,
  downloadLabel = 'Download Report',
  printLabel = 'Print Report',
  maxWidth = 'lg',
}) => (
  <Dialog open={open} onClose={onClose} fullWidth maxWidth={maxWidth} scroll="paper">
    {/* PrintStyles can be added here if needed */}
    <PrintStyles />
    <DialogTitle sx={{ p: 3, pb: 0 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
        <Box>
          <Typography variant="h5" fontWeight={500} gutterBottom>
            {title}
          </Typography>
        </Box>
        {showActions && (
          <Stack direction="row" spacing={1} alignItems="center">
            {onDownload && (
              <Button
                variant="contained"
                onClick={onDownload}
                sx={{
                  backgroundColor: '#404040',
                  color: 'white',
                  '&:hover': { backgroundColor: '#505050' },
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  textTransform: 'capitalize',
                }}
                startIcon={<DownloadIcon />}
              >
                {downloadLabel}
              </Button>
            )}
            {onPrint && (
              <Button variant="outlined" onClick={onPrint} sx={{ ml: 2 , textTransform: 'capitalize', 
                borderColor: '#404040', color:'#222'}}>
                {printLabel}
              </Button>
            )}
            <IconButton onClick={onClose} color="error" aria-label="Close Dialog">
              <HighlightOffIcon />
            </IconButton>
          </Stack>
        )}
      </Stack>
      <Divider sx={{ mt: 3 }} />
    </DialogTitle>
    <DialogContent dividers sx={{ p: 1, bgcolor: '#f9f9f9' }}  id="printable-report">
      {children}
    </DialogContent>
  </Dialog>
);

export default ReportDialog;